import { render, staticRenderFns } from "./FrequentSpammer.vue?vue&type=template&id=f4bad40c&scoped=true&"
import script from "./FrequentSpammer.vue?vue&type=script&lang=js&"
export * from "./FrequentSpammer.vue?vue&type=script&lang=js&"
import style0 from "./FrequentSpammer.vue?vue&type=style&index=0&id=f4bad40c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bad40c",
  null
  
)

export default component.exports